/*
 * Module for the Direct Deposit Receipts job criteria page
 */
rs.module("content/jobs/criteria/directdepositreceipts",

    ["common/select-helper", "common/visibility"],

    function (selectHelper, visibility) {

        // Initialize the page
        function initialize(jsSelectors, codeValues, constants, modes, outputTypeSets, outputTypes, rangeTypes, defaultPrinter, backendUrls) {
            var criteria = $.js(jsSelectors.criteria);

            var payrollTypeLoadingSpinner = criteria.js(jsSelectors.payrollTypeLoadingSpinner);
            var modeLoadingSpinner = criteria.js(jsSelectors.modeLoadingSpinner);
            var outputTypeLoadingSpinner = criteria.js(jsSelectors.outputTypeLoadingSpinner);
            var monthLoadingSpinner = criteria.js(jsSelectors.monthLoadingSpinner);
            var yearLoadingSpinner = criteria.js(jsSelectors.yearLoadingSpinner);

            var payrollTypeSelect = criteria.js(jsSelectors.payrollTypeSelect);
            var modeRadioContainer = criteria.js(jsSelectors.modeRadioContainer);
            var outputTypeSelect = criteria.js(jsSelectors.outputTypeSelect);
            var calendarContainer = criteria.js(jsSelectors.calendarContainer);
            var monthSelect = criteria.js(jsSelectors.monthSelect);
            var yearSelect = criteria.js(jsSelectors.yearSelect);
            var gridContent = criteria.js(jsSelectors.gridContent);
            var benefitsToIncludeContainer = criteria.js(jsSelectors.benefitsToIncludeContainer);
            var benefitsToIncludeSelect = criteria.js(jsSelectors.benefitsToIncludeSelect);
            var rangeContainer = criteria.js(jsSelectors.rangeContainer);
            var rangeTypeRadioContainer = criteria.js(jsSelectors.rangeTypeRadioContainer);
            var nameRangeContainer = criteria.js(jsSelectors.nameRangeContainer);
            var zipCodeRangeContainer = criteria.js(jsSelectors.zipCodeRangeContainer);
            var printerSelect = criteria.js(jsSelectors.printerSelect);
            var sortSelect = criteria.js(jsSelectors.sortSelect);
            var overrideToPrintContainer = criteria.js(jsSelectors.overrideToPrintContainer);
            var overrideToPrintCheckBox = criteria.js(jsSelectors.overrideToPrintCheckBox);
            
            // Get Select Helpers for selects where we're updating options and properties
            var outputTypeSelectHelper = selectHelper.getHelper(outputTypeSelect);
            var benefitsToIncludeSelectHelper = selectHelper.getHelper(benefitsToIncludeSelect);
            var printerSelectHelper = selectHelper.getHelper(printerSelect);
            var sortSelectHelper = selectHelper.getHelper(sortSelect);

            // Register payrollTypeSelect changed event
            payrollTypeSelect.change(() => updateContentDisplay(jsSelectors.payrollTypeSelect));

            // Register click event for mode radio buttons 
            modeRadioContainer.find("input").on("click", () => updateContentDisplay(jsSelectors.modeRadioContainer)); 

            // Register outputTypeSelect changed event
            outputTypeSelect.change(() => updateContentDisplay(jsSelectors.outputTypeSelect));

            // Register monthSelect changed event
            monthSelect.change(() => updateContentDisplay(jsSelectors.monthSelect));

            // Register yearSelect changed event
            yearSelect.change(() => updateContentDisplay(jsSelectors.yearSelect));

            // Register click event for range type radio buttons 
            rangeTypeRadioContainer.find("input").on("click", () => updateRangeDisplay());

            // Handle dynamic display of content
            function updateContentDisplay(jsSelector) {

                // get selected payroll type
                var selectedPayrollType = payrollTypeSelect.val();

                // get selected mode
                var selectedMode = modeRadioContainer.find("input:checked").val();

                // determine what has changed so we can react accordingly
                if (jsSelector == jsSelectors.payrollTypeSelect) {
                    payrollTypeLoadingSpinner.show();
                }
                else if (jsSelector == jsSelectors.modeRadioContainer) {
                    modeLoadingSpinner.show();

                    // repopulate output types if mode is recreate
                    if (selectedMode == modes.recreate) {
                        outputTypeSelectHelper.replaceOptions(outputTypeSets.excludeOnlineOnly);
                    }
                    else {
                        outputTypeSelectHelper.replaceOptions(outputTypeSets.all);
                    }

                    // show/hide month and year drop downs based on selected mode
                    visibility.setVisible(calendarContainer, selectedMode == modes.recreate);
                    
                }
                else if (jsSelector == jsSelectors.outputTypeSelect) {
                    outputTypeLoadingSpinner.show();
                }
                else if (jsSelector == jsSelectors.monthSelect) {
                    monthLoadingSpinner.show();
                }
                else if (jsSelector == jsSelectors.yearSelect) {
                    yearLoadingSpinner.show();
                }

                // get selected output type
                var selectedOutputType = outputTypeSelect.val();

                // display appropriate partial view (grid) based on selected mode 
                if (selectedMode == modes.create) {
                    _updateGridContentFrom(
                        backendUrls.getCreatePartialView,
                        {
                            payrollType: selectedPayrollType,
                            outputType: selectedOutputType
                        });
                }
                else if (selectedMode == modes.recreate) {

                    // get selected month and year
                    var month = monthSelect.val();
                    var year = yearSelect.val();

                    _updateGridContentFrom(
                        backendUrls.getRecreatePartialView,
                        {
                            payrollType: selectedPayrollType,
                            outputType: selectedOutputType,
                            month: month,
                            year: year
                        });
                }
                else {
                    _updateGridContentFrom(
                        backendUrls.getHeldReceiptsPartialView,
                        {
                            payrollType: selectedPayrollType,
                            outputType: selectedOutputType
                        });
                }

                // enable/disable the remaining child controls beneath the partial view (grid)
                updateChildControls(selectedPayrollType, selectedMode, selectedOutputType);
            }

            // Update grid content (partial views) from a url with parameters 
            function _updateGridContentFrom(url, parameters) {

                $.get(url,
                    parameters,
                    function done(html) {
                        gridContent.html(html);

                        payrollTypeLoadingSpinner.hide();
                        modeLoadingSpinner.hide();
                        outputTypeLoadingSpinner.hide();
                        monthLoadingSpinner.hide();
                        yearLoadingSpinner.hide();
                    }
                );
            }

            // enable/disable the remaining child controls, beneath the partial view (grid), based on combos of payroll type, mode and output type
            function updateChildControls(selectedPayrollType, selectedMode, selectedOutputType) {

                visibility.setVisible(benefitsToIncludeContainer, selectedMode == modes.create);
                visibility.setVisible(rangeContainer, selectedMode == modes.recreate);
                visibility.setVisible(overrideToPrintContainer, selectedMode == modes.create);

                if (selectedMode == modes.create) {

                    if (selectedPayrollType == codeValues.lumpSum || selectedOutputType == outputTypes.onlineOnly) {
                        benefitsToIncludeSelectHelper.setDisabled(true);
                        benefitsToIncludeSelectHelper.setValue(codeValues.allBenefits);
                    }
                    else {
                        benefitsToIncludeSelectHelper.setDisabled(false);
                    }

                    if (selectedOutputType == outputTypes.onlineOnly) {
                        overrideToPrintCheckBox.prop("disabled", true);
                        overrideToPrintCheckBox.setChecked(false);
                    }
                    else {
                        overrideToPrintCheckBox.prop("disabled", false);
                    }
                }
                else if (selectedMode == modes.recreate) {
                    updateRangeDisplay();
                }

                if (selectedOutputType == outputTypes.onlineOnly) {
                    sortSelectHelper.setDisabled(true);
                    sortSelectHelper.setValue(constants.name);
                }
                else {
                    sortSelectHelper.setDisabled(false);
                }

                if (selectedOutputType != outputTypes.print) {
                    printerSelectHelper.setDisabled(true);
                    printerSelectHelper.setValue(defaultPrinter);          
                }
                else {
                    printerSelectHelper.setDisabled(false);
                }
            }

            // Handle dynamic display of range fields
            function updateRangeDisplay() {

                // get selected range type
                var selectedRangeType = rangeTypeRadioContainer.find("input:checked").val();

                visibility.setVisible(nameRangeContainer, selectedRangeType == rangeTypes.name);
                visibility.setVisible(zipCodeRangeContainer, selectedRangeType == rangeTypes.zipCode);
            }
        }

        var exports = {
            initialize: initialize,
        };

        return exports;
    }
);